import { render, staticRenderFns } from "./IdentityList.vue?vue&type=template&id=736c9be3&scoped=true"
import script from "./IdentityList.vue?vue&type=script&lang=js"
export * from "./IdentityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736c9be3",
  null
  
)

export default component.exports